import { useEffect, useState } from "react";
import {
    loadGameData,
    updateFavouriteGame
} from "../../../games/services/casino.service";
import { GameDataList } from "../../../games/models/responses";
import { GameItem } from "./GameItem";
import { HomePageGameCategoriesResponse } from "../../models/response/homePageGameCategoriesResponse";
import homeService from "../../services/home.service";

type CategoryWithGames = {
    categoryId: string;
    categoryName: string;
    categoryHindiName: string;
    categoryImagePath: string;
    games: GameDataList[];
};

export function Games() {
    const [categoryWithGames, setCategoryWithGames] = useState<CategoryWithGames[]>([]);
    const [categories, setCategories] = useState<HomePageGameCategoriesResponse>();

    useEffect(() => {
        const fetchHomePageGameCategories = async () => {

            const response = await homeService.fetchHomePageGameCategories();

            if (response.isSuccess) {
                setCategories(response.data ?? undefined);
            }

        };

        fetchHomePageGameCategories();
    }, []);

    const fetchData = async () => {
        const validCategories: CategoryWithGames[] = [];

        if (categories?.details && categories.details.length > 0) {
            for (const category of categories.details) {
                const { gameListResponse: res } = await loadGameData(
                    null,
                    0,
                    null,
                    {
                        gameCategoryId: category.categoryId,
                        gameSupplierName: undefined,
                        isFavouriteGames: false,
                        pageSize: 15,
                    }
                );

                const games = res.gameList || [];

                if (games.length >= 5) {
                    validCategories.push({
                        categoryId: category.categoryId,
                        categoryName: category.categoryName,
                        categoryHindiName: category.categoryHindiName,
                        categoryImagePath: category.categoryImagePath,
                        games,
                    });
                }
            }

            setCategoryWithGames(validCategories);
        }
    };

    const handleFavouriteToggle = async (
        gameId: string,
        isFavourite: boolean
    ) => {

        await updateFavouriteGame(gameId, isFavourite);
        await fetchData();

    };

    useEffect(() => {
        if (categories?.details && categories.details.length > 0) {
            fetchData();
        }
    }, [categories]);

    return (
        <div>
            {categoryWithGames.map((category) => (
                <GameItem
                    key={category.categoryId}
                    categoryWithGames={category}
                    handleFavouriteToggle={handleFavouriteToggle}
                />
            ))}
        </div>
    );
}